var a=new class{};export{a as default};
